import config from "config";
import routing from "routing";
import isPes from "src/helpers/isPes";
import { useGetUserInfo } from "src/hooks/useUser";

export const useChatUrl = (): string | null => {
	const { data: user } = useGetUserInfo();

	if (!config.tawkTo || !user) return null;

	const panel = (config.urls?.panel ?? config.urls?.landing ?? "").replace(
		/\/+$/,
		"",
	);
	const search = new URLSearchParams({
		userId: String(user.id),
		specId: String(user.selectedSpecialisation?.id ?? ""),
		specName: String(user.selectedSpecialisation?.specialisation ?? ""),
		login: user.username ?? "",
		name: user.username ?? "",
		service: config.dictionary?.serviceName ?? "",
		isPes: String(isPes()),
		email: user.email ?? "",
	}).toString();

	return `${panel}${routing.paths.chatWidget}?${search}`;
};
